export default __webpack_public_path__ + "static/allred-556da2648b496d9b7a142cedcc3737c0.jpg";